import React from "react";
import styled, { css } from "styled-components";

const StyledStandardBlock = styled.section`
    box-sizing: border-box;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    padding: 1.75rem 1.5rem;
    z-index: 0;
    color: ${(props) => props.theme.colors[props.textColorKey || "neutral10"]};
	min-height: calc(100dvh - ${(props) => props.withSecondaryHeader ? "6rem" : "3rem"});
    ${(props) => props.alignment === "center" &&
		css `
			text-align: center;
		`}

    ${(props) => {
        if (props.portraitBg) {
            if (props.spaceBetween && props.portraitGradient) {
                return css`
                      background: linear-gradient(
                        0deg,
                        rgba(0, 0, 0, 0.6) 0,
						rgba(0, 0, 0, 0) 50%,
                        rgba(0, 0, 0, 0.6) 100%
                      ),
                      url(${props.portraitBg}) no-repeat center/cover
					  ${props.theme.colors[props.bgColorKey || "neutral1"]};
                  `;
            } else {
                return css`
                      background: ${props.portraitGradient ? `linear-gradient(
                        0deg,
                        rgba(0, 0, 0, 0.6) 0,
                        rgba(0, 0, 0, 0) 60%
                      	),` : ""}
                      url(${props.portraitBg}) no-repeat center/cover
					  ${props.theme.colors[props.bgColorKey || "neutral1"]};
                  `;
            }
        } else {
            return css`
                  background-color: ${props.theme.colors[props.bgColorKey || "neutral1"]};
              `;
        }
    }}

    @media screen and (orientation: landscape) {
		align-items: ${(props) =>
        props.alignment === "right" ? "flex-end" : props.alignment === "center" ? "center" : "flex-start"};
        ${(props) =>
            props.landscapeBg
                ? css`
                      background: ${props.landscapeGradient ? `linear-gradient(
                              90deg,
                              rgba(0, 0, 0, 0.7) 0%,
                              rgba(0, 0, 0, 0) 80%
                          ),` : ""}
                          url(${props.landscapeBg}) no-repeat center/cover
						  ${(props) => props.theme.colors[props.bgColorKey || "neutral1"]};
                  `
                : css`
                      background-color: ${(props) => props.theme.colors[props.bgColorKey || "neutral1"]};
                  `}
    }

    @media only screen and (min-width: ${(props) => props.theme.breakpoints.third}) {
        padding: 1.75rem 3rem;
    }

    @media only screen and (min-width: ${(props) => props.theme.breakpoints.sixth}) {
        padding: 2.5rem 4rem;
    }
`;

export const StandardContent = styled.div`
    box-sizing: border-box;
	max-width: 32rem;
	${(props) => props.spaceBetween &&
		css `
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			flex: 1 1 auto;
		`}

    @media screen and (orientation: landscape) {
		${(props)=>(props.alignment === "center" ?
			"text-align: center;" :
			(props.alignment === "right") ? 
				"text-align: right;" : "text-align: left;"
		)}
		${(props) => props.spaceBetween &&
		css `
			flex: 0 1 auto;
		`}
    }
`;

export const StandardContentTop = styled.div`
`;

export const StandardContentBottom = styled.div`
	:first-child {
		margin-top: 0;
	}

	:last-child {
		margin-bottom: 0;
	}
`;

const schemeMap = {
    dark: { bg: "neutral1", text: "neutral10" },
    light: { bg: "neutral10", text: "neutral1" },
    yellow: { bg: "yellow6", text: "neutral1" },
};

export const StandardBlock = ({
    id,
    children,
    colorScheme = "light",
    portraitBg,
    landscapeBg,
    portraitGradient = false,
    landscapeGradient = false,
	spaceBetween = false,
    alignment = "left",
    withSecondaryHeader = false,
}) => {
    const scheme = schemeMap[colorScheme] || schemeMap.light;

    return (
        <StyledStandardBlock
            id={id}
            alignment={alignment}
            portraitBg={portraitBg}
            landscapeBg={landscapeBg}
            portraitGradient={portraitGradient}
            landscapeGradient={landscapeGradient}
            bgColorKey={scheme.bg}
            textColorKey={scheme.text}
			spaceBetween={spaceBetween}
            withSecondaryHeader={withSecondaryHeader}
        >
            {/* pass alignment prop down to all children so they can respond */}
            {React.Children.map(children, (child) =>
                React.isValidElement(child)
                    ? React.cloneElement(child, { alignment, spaceBetween })
                    : child
            )}
        </StyledStandardBlock>
    );
};

export default StandardBlock;